<script setup>
const route = useRoute()
const { data: golfInfo } = await useFetch('/api/golf/info', { query: { url: route.path } })
if (!golfInfo.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('point', golfInfo.value.name)
const breadCrumbList = getBreadCrumb(route.params.area, route.params.pref, golfInfo.value.name)
</script>

<template>
  <NuxtLayout
    name="point"
    :bread-crumb-list="breadCrumbList"
  >
    <div class="frame">
      <WeatherForecast
        :title="golfInfo.name"
        :center="{ lon: golfInfo.lon_dd, lat: golfInfo.lat_dd }"
      />
    </div>
    <template #main-center1>
      <GolfLive :center="{ lon: golfInfo.lon_dd, lat: golfInfo.lat_dd }" />
      <GolfWind
        :id="golfInfo.id"
        :center="[golfInfo.lon_dd, golfInfo.lat_dd]"
      />
    </template>
    <template #main-center2>
      <GolfInfo :golf-info="golfInfo" />
    </template>
    <template #main-bottom>
      <GolfLog
        :name="golfInfo.name"
        :pref="getPrefectureName(route.params.pref)"
        :center="{ lon: golfInfo.lon_dd, lat: golfInfo.lat_dd }"
      />
    </template>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
